export default "__VITE_ASSET__Cr1$0DK0__"